import {notifications} from "@atttomyx/shared-constants";

export const APP_NAME = "Connections";
export const APP_TAG_LINE = "For the important people in your life";

// export const API_BASE_URL = "http://localhost:8080";
export const API_BASE_URL = "https://connections-app-1088050047717.us-central1.run.app";
export const WEB_BASE_URL = "https://connections.milesoft.app";

export const PATH_DEEP_LINK = "/deep-link";

export const CLOUDINARY_ID = "cuteandfuzzy";

export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyA9Dj9SL_KXAQw4DfB-66XmJvyAUytOMdo",
    authDomain: "cf-notifier.firebaseapp.com",
    projectId: "cf-notifier",
    storageBucket: "cf-notifier.appspot.com",
    messagingSenderId: "741330969895",
    appId: "1:741330969895:web:795f316c4aca845967f502",
    measurementId: "G-7YK8FMDCTM"
};

export const NAMESPACE = "connections";
export const KEY_VERSION = "version";

export const ADD_NEW = "Add new...";

export const LAYOUT_VERTICAL = "Vertical";
export const LAYOUT_HORIZONTAL = "Horizontal";

export const VIEW_GRAPH = "Graph";
export const VIEW_CARDS = "Cards";

export const OBSERVER_APP = "app";

export const NOTIFICATION_TYPES = {
    account_joined: {
        admin: true,
        short: "New User",
        long: "A new user joins the account",
        delivery: notifications.DELIVERY_APP,
    },
};

export const TOPICS = {};

export const PAGE_LOGIN = "/login";
export const PAGE_RECOVERY = "/recovery";
export const PAGE_WELCOME = "/welcome";
export const PAGE_NEW_USER = "/newUser";

export const PAGE_PROFILE = "/profile";
export const PAGE_OPTIONS = "/options";
export const PAGE_PASSWORD = "/password";

export const PAGE_ABOUT = "/about";
export const PAGE_NOTIFICATIONS = "/notifications";

export const PAGE_CALENDAR = "/calendar";
export const PAGE_PEOPLE = "/people";

export const PAGE_HOME = PAGE_NOTIFICATIONS;

export const PAGES_MAIN = [
    PAGE_NOTIFICATIONS,
    PAGE_CALENDAR,
    PAGE_PEOPLE,
];

export const PAGES_MORE = [
    PAGE_PROFILE,
    PAGE_OPTIONS,
    PAGE_PASSWORD,
    PAGE_ABOUT,
];

export const PRIVATE_PAGES_EXACT = [].concat(PAGES_MAIN).concat(PAGES_MORE);

export const PRIVATE_PAGES_STARTS_WITH = [];

export const PUBLIC_PAGES_EXACT = [
    PAGE_LOGIN,
    PAGE_RECOVERY,
];

export const PUBLIC_PAGES_STARTS_WITH = [];
